export function openDependency() {
  window
    .open(`https://www.npmjs.com/package/${this.state.key}`, '_blank')
    .focus()
}

export function upgradeDependency() {
  const { key, version: targetVersion, type } = this.state

  window.fetch(`https://registry.npmjs.com/${key}`).then(async (res) => {
    const { versions: v } = await res.json()
    const versions = Object.keys(v)

    const [targetMajor, targetMinor] = targetVersion.split('.').map(Number)

    const matchingPatches = versions.filter((version) => {
      if (version.includes('-') || version.includes('+')) {
        return false
      }

      const [major, minor] = version.split('.').map(Number)
      return major === targetMajor && minor === targetMinor
    })

    const latest = matchingPatches.reduce((initial, current) => {
      const [, , currentPatch] = current.split('.').map(Number)
      const [, , latestPatch] = initial.split('.').map(Number)

      return currentPatch > latestPatch ? current : latest
    }, '')

    // TO DO: Adding message toasts to warn the status of the upgrade
    this.sdk.updateItem(
      'dependencies',
      {
        key,
        value: latest || targetVersion,
        type,
        version: latest || targetVersion
      },
      { message: 'Upgraded dependency' }
    )
  })
}

export function fetchLatestDependency() {
  this.sdk.updateItem(
    'dependencies',
    {
      key: this.state.key,
      value: 'latest',
      type: this.state.type,
      version: 'latest'
    },
    { message: 'Fetched latest dependency' }
  )
}

export function rebuildDependency() {
  // TO DO: Waiting for a SDK function or something to rebuild some dependency if necessary
  // https://symbo-ls.slack.com/archives/C084QG0K7A7/p1739831059737529
}

export async function deleteDependency() {
  return this.call('removeItem', 'dependency', this.state.key)
}
